import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchClinicResources } from "../../store/thunks/resourceThunk";
import ResourceFormModal from "../../components/ResourceFormModal";
import Table from "../../applicationUi/components/Table";

function ResourcePage() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const resources = useSelector((state) => state.resources.resources);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);

  useEffect(() => {
    if (user?.defaultLocation) {
      dispatch(fetchClinicResources(user.defaultLocation));
    }
  }, [dispatch, user?.defaultLocation]);

  const handleAddResource = () => {
    setSelectedResource(null);
    setIsModalOpen(true);
  };

  const handleEditResource = (resourceId) => {
    const resource = resources.find(r => r._id === resourceId);
    setSelectedResource(resource);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedResource(null);
  };

  const handleModalSave = () => {
    dispatch(fetchClinicResources(user.defaultLocation));
  };

  // Define table columns
  const columns = [
    {
      header: "Name",
      accessor: "name",
      sortable: true,
    },
    {
      header: "Type",
      accessor: "type",
      sortable: true,
    },
    {
      header: "Description",
      accessor: "description",
      sortable: false,
    },
    {
      header: "Status",
      accessor: (resource) => (
        <span
          className={`inline-flex rounded-full px-2 py-1 text-xs font-medium ${
            resource.status === "active"
              ? "bg-green-100 text-green-800"
              : resource.status === "maintenance"
              ? "bg-yellow-100 text-yellow-800"
              : "bg-red-100 text-red-800"
          }`}>
          {resource.status.charAt(0).toUpperCase() + resource.status.slice(1)}
        </span>
      ),
      sortable: true,
    },
  ];

  // Define table actions
  const actions = [
    {
      label: "Add Resource",
      onClick: handleAddResource,
    },
  ];

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <Table
        title="Resources"
        description="A list of all resources in your clinic including their name, type, description, and status."
        columns={columns}
        data={resources}
        actions={actions}
        onRowClick={handleEditResource}
        showPagination={false}
      />

      <ResourceFormModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        onSave={handleModalSave}
        mode={selectedResource ? "edit" : "add"}
        resource={selectedResource}
      />
    </div>
  );
}

export default ResourcePage;
